import {registerReactPartial} from '@github-ui/react-core/register-partial'

import {NetworkGraphTable} from './NetworkGraphTable'

// The partial name must match the package name (enforced by the `react-partial-name` lint rule).
// Living in its own package keeps this bundle — and the Primer table/dialog code it pulls in — out
// of the always-loaded `network-graph-element` canvas bundle. The framework only fetches it when
// Rails renders a `<react-partial partial-name="network-graph-table-view">` anchor (flag-gated).
registerReactPartial('network-graph-table-view', {
  Component: NetworkGraphTable,
})
